module.exports = __webpack_public_path__ + "static/media/app-logo2.009232bd.svg";